import styled, { css } from "styled-components";
import {
  asType,
  capitalize,
  mapObject,
  parseCSS,
  parseNumber,
  parsePrice,
} from "scripts/FunctionsBundle";
import NewText from "./NewText";
import { GlobalContext } from "App";
import { useContext, useState } from "react";
import { ACNH_Element } from "utils/class-types";
import Breaker from "./Breaker";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
type _Capturapedia = import("utils/class-types").Capturapedia;
// SearchTable => Rename all instances to use
type SearchTableProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _SearchTable = (props: SearchTableProps) => {
  const {
    get: { Capturapedia },
  } = useContext(GlobalContext);

  const [formData] = useState<{
    category: keyof _Capturapedia;
    objects: { [Property in keyof _Capturapedia]-?: _Capturapedia[Property] };
  }>({
    category: "bichos",
    objects: mapObject(ACNH_Element.classes, (cat, _, obj) => {
      return new obj[cat]();
    }),
  });

  const [render, setRender] = useState(0);
  const [selectMode, setSelectMode] = useState(true);

  type cat = {
    [Property in keyof _Capturapedia]-?: _Capturapedia[Property];
  }[keyof _Capturapedia];

  var {
    _specifics,
    update,
    ...filter
  }: { [property in keyof cat]?: cat[property] } = {};

  const filterTags: string[] = [];

  for (const key in filter) {
    filterTags.push(key);
  }

  // hot data
  const categoryName = formData.category;
  const currentCategory = formData.objects[categoryName];

  // ------------------------------------------------------------------------------------ HANDLE CHANGE
  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) {
    var variable: string = e.target.id;
    var value: string | number = e.target.value;

    if (e.target.name === "number") {
      value = parseNumber(value);
      console.log(value, e.target.value);
    }

    currentCategory.update({ [variable]: value });

    if (render >= 65530) setRender(-65530);
    else setRender((val) => val + 1);
  }

  // ------------------------------------------------------------------------------------ CHANGE BINARY
  function bin(str: string, pos: number, val?: number) {
    var chg = str[pos];
    if (chg === "0") chg = "1";
    else chg = "0";

    if (val) chg = "" + val;

    return str.slice(0, pos) + chg + str.slice(pos + 1);
  }

  // ------------------------------------------------------------------------------------ HANDLE DRAG
  function drag(
    e: React.DragEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>
  ) {
    var evtype = asType<"change" | "dragstart" | "dragenter">(e.type);
    var eltype = asType<"month" | "hour">(e.target["name"]);
    var elindex = parseNumber(e.target["id"]);

    // Where to change state -> on change, on start drag
    if (
      evtype === "change" ||
      evtype === "dragstart" ||
      e.target["checked"] !== selectMode
    ) {
      currentCategory[eltype] = bin(currentCategory[eltype], elindex);
      if (evtype === "dragstart") setSelectMode(!e.target["checked"]);
    }

    if (render >= 65530) setRender(-65530);
    else setRender((val) => val + 1);
  }

  if (Object.keys(Capturapedia).length <= 0)
    return (
      <div>
        <NewText
          _text={"Loading..."}
          _type={"subtitle"}
          _align={"center"}
          _this={{ _bold: {}, _custom: { _add: { padding: "0.5rem 2rem" } } }}
        />
      </div>
    );

  return (
    <div className={props.className}>
      <div className={"filters-container"}>
        <NewText
          _text={"Filtros activos: "}
          _type={"subtitle"}
          _variant={2}
          _this={{ _bold: {} }}
        />

        <div className={"filters"}>
          {filterTags.map((k) => (
            <NewText _text={capitalize(k)} _del_margin />
          ))}
        </div>
      </div>

      <Breaker _size={"4rem"} />

      <table className={"cool-table"}>
        <thead>
          <tr>
            {[
              "Categoría",
              "Nombre",
              "Precio",
              "Imagen",
              "Consideraciones",
              "Eliminar",
            ].map((tag, i) => {
              return (
                <td key={i}>
                  <NewText _text={tag} _del_margin _this={{ _bold: {} }} />
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(Capturapedia).map((category) => {
            return Capturapedia[category].map(
              (element: any, catind: number) => {
                var temp = asType<ACNH_Element>(element);
                return (
                  <tr key={catind}>
                    {[
                      "category",
                      "name",
                      "price",
                      "image",
                      "considerations",
                    ].map((key, ind) => {
                      return (
                        <td key={ind}>
                          <NewText
                            _text={
                              key === "category"
                                ? capitalize(category)
                                : key === "price"
                                ? parsePrice(temp[key])
                                : temp[key]
                            }
                            _del_margin
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              }
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

// ################################ STYLES ################################
const SearchTable = styled(_SearchTable).attrs((props): SearchTableProps => {
  return { ...props };
})`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default SearchTable;

/*
<form className={""} onSubmit={(e) => e.preventDefault()}>
        {/* ###### Información General ###### * /}
        <fieldset className="field-legend">
          <legend>
            <NewText
              _text={"Información general"}
              _type={"subtitle"}
              _del_margin
              _this={{ _bold: {} }}
            />
          </legend>

          {/* ### Categoria ### * /}
          <label htmlFor={"category"}>
            <NewText _text={"Categoría: "} _type={"subtitle"} _del_margin />
          </label>
          <select
            id={"category"}
            onChange={(e) => {
              formData.category = asType<"bichos">(e.target.value);
              setRender(render + 1);
            }}
            value={formData.category}
          >
            <option disabled>- Selecciona -</option>
            {Object.keys(formData.objects).map((category, index) => (
              <option key={index} value={category}>
                {capitalize(category)}
              </option>
            ))}
          </select>

          {/* ### Nombre ### * /}
          <label htmlFor={"name"}>
            <NewText _text={"Nombre: "} _type={"subtitle"} _del_margin />
          </label>
          <input
            id={"name"}
            placeholder={"< Empty >"}
            onChange={handleChange}
            value={currentCategory.name}
            autoComplete={"off"}
          />

          {/* ### Precio ### * /}
          <label htmlFor={"price"}>
            <NewText _text={"Precio: "} _type={"subtitle"} _del_margin />
          </label>
          <input
            id={"price"}
            name={"number"}
            placeholder={"< Empty >"}
            onChange={handleChange}
            value={parsePrice(currentCategory.price)}
            autoComplete={"off"}
            maxLength={"$999,999".length}
            style={{ width: "auto" }}
          />
        </fieldset>

        {/* ###### Horario de aparicion ###### * /}
        {currentCategory.month !== undefined &&
        currentCategory.hour !== undefined ? (
          <fieldset className="field-legend">
            <legend>
              <NewText
                _text={"Horario de aparición"}
                _type={"subtitle"}
                _del_margin
                _this={{ _bold: {} }}
              />
            </legend>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "1rem",
                }}
              >
                {/* ###################### MESES ###################### * /}
                {new Array<number>(12).fill(1).map((_, index) => {
                  return (
                    <div
                      style={{
                        marginLeft: "0.5rem",
                        width: "3rem",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      key={index}
                    >
                      <label
                        htmlFor={`${index}-month`}
                        style={{ position: "absolute", pointerEvents: "none" }}
                      >
                        <NewText
                          _text={
                            [
                              "Ene",
                              "Feb",
                              "Mar",
                              "Abr",
                              "May",
                              "Jun",
                              "Jul",
                              "Ago",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dic",
                            ][index]
                          }
                          _this={{ _bold: {} }}
                          _del_margin
                        />
                      </label>
                      <input
                        type={"checkbox"}
                        id={`${index}-month`}
                        name={"month"}
                        draggable
                        onDragEnter={drag}
                        onDragStart={drag}
                        onChange={drag}
                        checked={currentCategory.month[index] === "1"}
                        style={{ width: "2.5rem", height: "2.5rem" }}
                      />
                    </div>
                  );
                })}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "1rem",
                }}
              >
                {/* ###################### HORAS ###################### * /}
                {new Array<number>(24).fill(1).map((_, index) => {
                  return (
                    <div
                      style={{
                        marginLeft: "0.5rem",
                        width: "3rem",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      key={index}
                    >
                      <label
                        htmlFor={`${index}-hour`}
                        style={{ position: "absolute", pointerEvents: "none" }}
                      >
                        <NewText
                          _text={(index > 9 ? index : "0" + index) + ":00"}
                          _del_margin
                          _this={{
                            _bold: {},
                          }}
                        />
                      </label>
                      <input
                        type={"checkbox"}
                        id={`${index}-hour`}
                        name={"hour"}
                        draggable
                        onDragEnter={drag}
                        onDragStart={drag}
                        onChange={drag}
                        checked={currentCategory.hour[index] === "1"}
                        style={{ width: "2.5rem", height: "2.5rem" }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </fieldset>
        ) : (
          <></>
        )}

        {/* ###### Especificaciones ###### * /}
        {Object.keys(currentCategory!._specifics).length > 0 ? (
          <fieldset className="field-legend">
            <legend>
              <NewText
                _text={"Especificaciones"}
                _type={"subtitle"}
                _this={{ _bold: {} }}
                _del_margin
              />
            </legend>

            {/* ### Crear un selector para cada especificación ### * /}
            {Object.keys(currentCategory!._specifics).map((specific, index) => {
              return (
                <div key={index}>
                  <label htmlFor={specific}>
                    <NewText
                      _text={
                        specific[0].toUpperCase() + specific.slice(1) + ": "
                      }
                      _type={"subtitle"}
                      _del_margin
                    />
                  </label>
                  <select
                    id={specific}
                    onChange={handleChange}
                    value={currentCategory[specific]}
                  >
                    <option disabled>- Selecciona -</option>
                    {currentCategory!._specifics[specific].map(
                      (option: string, index: number) => (
                        <option key={index} value={option}>
                          {option[0].toUpperCase() + option.slice(1)}
                        </option>
                      )
                    )}
                  </select>
                </div>
              );
            })}
          </fieldset>
        ) : (
          <></>
        )}

        {/* ###### Información adicional ###### * /}
        <fieldset className={"field-legend"}>
          <legend>
            <NewText
              _text={"Información adicional"}
              _type={"subtitle"}
              _this={{ _bold: {} }}
              _del_margin
            />
          </legend>
          <label htmlFor={"considerations"}>
            <NewText
              _text={"Consideraciones: "}
              _type={"subtitle"}
              _del_margin
            />
          </label>
          <input
            id={"considerations"}
            placeholder={"< Empty >"}
            onChange={handleChange}
            value={currentCategory.considerations}
            autoComplete={"off"}
            style={{
              fontSize: "1.25rem",
              marginRight: "3rem",
              padding: "0rem 0.3rem",
              width: "25rem",
            }}
          />
        </fieldset>
      </form>
*/
